export default __webpack_public_path__ + "static/media/cladding30.a92baa1f.jpeg";